/**
 * EMPTY CELL
 * Cellule pour afficher un placeholder quand une valeur est vide
 */

interface EmptyCellProps {
  value: string | number | null | undefined;
  emptyMessage?: string;
  className?: string;
}

export function EmptyCell({ value, emptyMessage = '-', className }: EmptyCellProps) {
  const displayValue = value ?? emptyMessage;
  const isEmpty = value === null || value === undefined || value === '';

  return (
    <span className={`text-sm ${isEmpty ? 'text-zinc-500' : ''} ${className || ''}`}>
      {displayValue}
    </span>
  );
}
